
import React from 'react';
import {FormFeedback} from 'reactstrap'

import { useFormikContext, getIn } from 'formik';

const MyErrorMessage = ({ name }) => {
    const formikContext = useFormikContext();
    const touched = formikContext?.touched || {};
    const errors = formikContext?.errors || {};
    const submitCount = formikContext?.submitCount || 0;

    const error = getIn(errors, name);
    const invalid = error && (getIn(touched, name) || submitCount > 0);
    return <FormFeedback className={invalid ? 'd-block' : null} data-error-name={name}><h5>{invalid ? error : null}</h5></FormFeedback>
   
}


export default MyErrorMessage; 